import { PmcPerformancePage } from './PmcPerformanceRedPage'

export function PmcPerformanceGreenPage() {
  return <PmcPerformancePage reportType="green" />
}
